import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { MatCheckboxModule, MatTooltipModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputComponent } from './fc-search-many-input.component';


@NgModule({
  entryComponents: [
    FcSearchManyInputComponent
  ],
  declarations: [
    FcSearchManyInputComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatCheckboxModule,
    ScrollingModule,
    MatTooltipModule
  ],
  exports: [
    FcSearchManyInputComponent
  ],
})
export class FcSearchManyInputModule {}
